/**
 * 403 côté interface : la session est valide mais le rôle ne suffit pas.
 * On l’affiche plutôt que de rediriger — une redirection ferait croire à une
 * déconnexion, et pourrait boucler.
 */

import { Link } from 'react-router'

import { LIBELLES_ROLE_UTILISATEUR, type RoleUtilisateur } from '@tb/shared'

import { CHEMINS } from '../lib/chemins'
import { classesBouton } from '../ui/Button'
import { EmptyState } from '../ui/EmptyState'

export interface AccesRefuseProps {
  readonly rolesAttendus?: readonly RoleUtilisateur[] | undefined
}

export function AccesRefuse({ rolesAttendus }: AccesRefuseProps) {
  const attendus =
    rolesAttendus === undefined || rolesAttendus.length === 0
      ? null
      : rolesAttendus.map((role) => LIBELLES_ROLE_UTILISATEUR[role]).join(', ')

  return (
    <EmptyState
      titre="Accès refusé"
      description={
        attendus === null
          ? "Votre rôle ne permet pas d’ouvrir cet écran."
          : `Cet écran est réservé aux rôles : ${attendus}.`
      }
      action={
        <Link to={CHEMINS.admin} className={classesBouton('secondaire')}>
          Retour à l’accueil
        </Link>
      }
    />
  )
}
